import { z } from "zod";
import { exteriorSpaces, interiorSpaces, styles } from "./types";

export const projectSchema = z
  .object({
    kind: z.enum(["interior", "exterior"]),
    space: z.string().min(1, "Odaberi vrstu prostora."),
    style: z.enum(styles),
    budgetMin: z.coerce.number().min(0).max(500_000),
    budgetMax: z.coerce.number().min(100).max(500_000),
    colours: z.array(z.string()).min(1, "Odaberi barem jednu boju."),
    keep: z.string().max(500),
    remove: z.string().max(500),
    notes: z.string().max(1_500),
    wallWidthCm: z.preprocess(
      (value) => (value === "" || (typeof value === "number" && Number.isNaN(value)) ? undefined : value),
      z.coerce.number().min(30).max(5_000).optional(),
    ),
  })
  .superRefine((data, ctx) => {
    const allowed = data.kind === "interior" ? interiorSpaces : exteriorSpaces;
    if (!(allowed as readonly string[]).includes(data.space)) {
      ctx.addIssue({ code: "custom", path: ["space"], message: "Odabrani prostor ne odgovara kategoriji." });
    }
    if (data.budgetMax < data.budgetMin) {
      ctx.addIssue({
        code: "custom",
        path: ["budgetMax"],
        message: "Najveći budžet mora biti veći od početnog.",
      });
    }
  });

export const metadataUrlSchema = z
  .string()
  .url()
  .transform((value, ctx) => {
    const url = new URL(value);
    if (!["http:", "https:"].includes(url.protocol)) {
      ctx.addIssue({ code: "custom", message: "Dopuštene su samo HTTP i HTTPS poveznice." });
      return z.NEVER;
    }
    return url;
  });

export const MAX_UPLOAD_BYTES = 12 * 1024 * 1024;
const allowedMagic = [
  [0xff, 0xd8, 0xff],
  [0x89, 0x50, 0x4e, 0x47],
  [0x52, 0x49, 0x46, 0x46],
];

export function validateImageBytes(
  bytes: Uint8Array,
  mime: string,
  maxBytes = MAX_UPLOAD_BYTES,
): string | null {
  if (bytes.byteLength === 0) return "Datoteka je prazna.";
  if (bytes.byteLength > maxBytes) return "Fotografija smije imati najviše 12 MB.";
  if (!["image/jpeg", "image/png", "image/webp"].includes(mime)) {
    return "Odaberi JPG, PNG ili WebP fotografiju.";
  }
  if (!allowedMagic.some((signature) => signature.every((byte, index) => bytes[index] === byte))) {
    return "Sadržaj datoteke ne odgovara podržanom formatu slike.";
  }
  return null;
}
